import React from "react";
import styled from "styled-components";

import { ReactComponent as DocxSvg } from "../../assets/images/Docx.svg"; // eslint-disable-line
import { ReactComponent as PdfSvg } from "../../assets/images/Pdf.svg"; // eslint-disable-line

import PortfolioDocx from "./Portfolio.doc";
import PortfolioPdf from "./Portfolio.pdf";

const StyleFooter = styled.footer`
  display: flex;
  justify-content: center;
  gap: 1rem;
  border-top: 2px solid #191925;
  padding: 1.5rem 2rem;
`;

export const Footer = () => {
  return (
    <StyleFooter>
      <a
        href={PortfolioDocx}
        target="_blank"
        rel="noopener noreferrer"
        download="Portfolio.doc"
      >
        <DocxSvg />
      </a>
      <a
        href={PortfolioPdf}
        target="_blank"
        rel="noopener noreferrer"
        download="Portfolio.pdf"
      >
        <PdfSvg />
      </a>
    </StyleFooter>
  );
};
